import React from "react";
import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "./headerWithBackButton.module.less";
import {Header} from "@src/Features/MainLayout/Components/Header/Header.tsx";
import {useNavigate} from "react-router";
import {Button, ButtonType} from "@UI/components/controls/Button/Button.tsx";
import {ColorNames} from "@UI/theme/generated/ColorNames.ts";
import {ArrowPointerLeft} from "@UI/components/icons/ArrowPointerLeft.tsx";
import {Title_20_Coral_Strong_emphasis_20} from "@UI/typography/generated/typography.tsx";
import {Gt} from "@src/i18n/Gt.tsx";
import {FiltersButton} from "@src/CommonComponents/FiltersButton/FiltersButton.tsx";
import cn from "classnames";


interface Props extends React.PropsWithChildren {
    title: string,
    backLink?: string
    showFilters?: boolean
    hideOnMobile?: boolean
}

export const BackButtonRow = ({title, backLink, hideOnMobile = true}: Props) => {
    const navigate = useNavigate()
    return (
        <Stack className={cn({[styles.noMobile]: hideOnMobile})}>
            <Button
                className={styles.backLink}
                color={ColorNames.OBSIDIAN}
                icon={<ArrowPointerLeft size={30}/>}
                type={ButtonType.text}
                onClick={() => backLink ? navigate(backLink) : navigate(-1)}
            />
            <Stack className={styles.title}>
                <Title_20_Coral_Strong_emphasis_20>
                    <Gt>{title}</Gt>
                </Title_20_Coral_Strong_emphasis_20>
            </Stack>
        </Stack>
    )
}

export const HeaderWithBackButton = ({title, backLink, showFilters}: {
    title: string,
    backLink?: string,
    showFilters: boolean
}) => {
    const navigate = useNavigate()

    return (
        <Stack className={styles.header} alignItems={"center"} justifyContent={"space-between"}>
            <Button
                className={styles.backLink}
                color={ColorNames.OBSIDIAN}
                icon={<ArrowPointerLeft size={30}/>}
                type={ButtonType.text}
                onClick={() => backLink ? navigate(backLink) : navigate(-1)}
            />
            <Stack className={styles.title}>
                <Title_20_Coral_Strong_emphasis_20>
                    <Gt>{title}</Gt>
                </Title_20_Coral_Strong_emphasis_20>
            </Stack>

            <Stack className={styles.filter}>
                {showFilters &&
                    <FiltersButton/>
                }
            </Stack>
        </Stack>
    )
}

export const BackButtonViewPage: React.FC<Props> = ({children, title, backLink, showFilters = false}) => {
    return (
        <Stack grow alignItems='center' direction={"column"} gap={16}>
            <HeaderWithBackButton title={title} backLink={backLink} showFilters={showFilters}/>
            <Stack className={styles.commonHeader}>
                <Header showFilters={showFilters}/>
            </Stack>

            <Stack className={styles.content}>
                {children}
            </Stack>
        </Stack>
    )
}